// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3DnF7","error":"Textarea_error__3q7R5","readonly":"Textarea_readonly__2n3B2","disabled":"Textarea_disabled__1UXB1"};